import { useMemo } from "react";
import { DispatcherOrderEntryAdditionalField } from "@api/graphql/generated/generated-types";
import { isCallerPhoneRequired } from "@src/common/lib/requiredAdditionalFieldUtils";

export function useIsCallerPhoneRequired(
  dispatcherOrderEntryAdditionalFields?: DispatcherOrderEntryAdditionalField[]
): boolean {
  return useMemo(
    () => isCallerPhoneRequired(dispatcherOrderEntryAdditionalFields),
    [dispatcherOrderEntryAdditionalFields]
  );
}
